import React, { Component, } from 'react';
import { arrayOf, object, func, string, } from 'prop-types';
import styled from 'styled-components';
import { NavLink, withRouter, } from 'react-router-dom';
import { color, } from '../../legacy-tv-dls';
// import { Target } from 'react-popper';

const TabList = styled.div`
  border: 1px solid #e6e6e6;
  margin: 20px 20px 0;
  box-sizing: border-box;
  display: inline-block;
  `;
const StyledNavLink = styled(NavLink)`
  display: inline-block;
  background: #e5e5e5;
  min-width: 100px;
  text-align: center;
  padding: 5px;
  text-decoration: none;
  color: #999;
  transition: .1s;
  border: solid 3px #f5f5f5;
  border-radius: 5px;
  &:hover {
    background-color: #ddd
  }
`;
const StyledTab = styled.div`
display: inline-block;
background: #e5e5e5;
min-width: 100px;
text-align: center;
padding: 5px;
text-decoration: none;
cursor: pointer;
color: #999;
transition: .1s;
border: solid 3px #f5f5f5;
border-radius: 5px;
&:hover {
  background-color: #ddd
}
`;

export class TabBar extends Component {
  static propTypes = {
    tabs: arrayOf(object),
    match: object.isRequired,
    handleClick: func,
    activeTabName: string,
  }
  static defaultProps = {
    tabs: [],
    handleClick: null,
    activeTabName: null,
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { projectId, } = this.props.match.params;
    const { handleClick, activeTabName, tabs, } = this.props;
    const activeStyle = {
      backgroundColor: color.brand.primary['500'],
      color: '#fff',
    };
    return (
      <TabList>
        {
          handleClick
            ? tabs.map(tab => (
              <StyledTab
                key={tab.name}
                onClick={() => handleClick(...tab.args)}
                style={activeTabName === tab.name ? activeStyle : {}}
                replace
              >
                {tab.name}
              </StyledTab>
            ))
            : tabs.map(tab => (
              <StyledNavLink
                key={tab.url}
                to={`/${projectId}/${tab.url}`}
                activeStyle={activeStyle}
                replace
              >
                {tab.name}
              </StyledNavLink>
            ))
        }
      </TabList>
    );
  }
}

export default withRouter(TabBar);



// WEBPACK FOOTER //
// ./src/components/TabBar/index.js